/**
 * "Order on WhatsApp" checkout replacement (button markup in snippets/cart-summary.liquid).
 *
 * Loaded globally from layout/theme.liquid: the cart drawer's contents (including
 * the button) are injected by the Section Rendering API after an add-to-cart, and
 * scripts inside injected HTML never execute — an inline handler in the snippet
 * only works when the cart was non-empty at page load.
 */
if (!window.__srxWaOrderInit) {
  window.__srxWaOrderInit = true;

  // The drawer's "Check out" link navigates to the complete-order page; close
  // the drawer first so its slide-out plays instead of it sitting open while
  // the new page loads.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('#cart-drawer a.cart__checkout-button');
    if (!link) return;
    const drawer = /** @type {{ close?: () => void } | null} */ (link.closest('theme-drawer'));
    drawer?.close?.();
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-srx-wa-number]');
    if (!btn || btn.disabled) return;

    // On the complete-order page the button carries data-srx-wa-details:
    // validate the form first (synchronously, before any window opens) and
    // append the entered contact + address to the message.
    let details = '';
    if (btn.hasAttribute('data-srx-wa-details')) {
      const form = document.querySelector('[data-srx-checkout-form]');
      if (form) {
        if (!form.reportValidity()) return;
        details = [...form.querySelectorAll('input[data-label], textarea[data-label]')]
          .map((field) => (field.value.trim() ? `${field.dataset.label}: ${field.value.trim()}` : null))
          .filter(Boolean)
          .join('\n');
      }
    }

    // Open the tab synchronously inside the click gesture — popup blockers
    // reject window.open calls made after an awaited fetch. If it's blocked
    // anyway, fall back to same-tab navigation (also the nicer path on mobile,
    // where wa.me hands off to the WhatsApp app).
    let win = null;
    try {
      win = window.open('about:blank', '_blank');
    } catch {}

    const go = (url) => {
      if (win && !win.closed) {
        try { win.opener = null; } catch {}
        win.location.href = url;
        win.focus?.();
      } else {
        window.location.href = url;
      }
    };

    (async () => {
      btn.disabled = true;
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        if (!cart.items?.length) {
          win?.close();
          return;
        }
        const money = (cents) =>
          window.SRXCurrency
            ? window.SRXCurrency.format(cents)
            : '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' USD';
        const lines = cart.items.map((item) => {
          const options = (item.options_with_values || [])
            .filter((o) => o.value && o.value !== 'Default Title')
            .map((o) => `${o.name}: ${o.value}`);
          const properties = Object.entries(item.properties || {})
            .filter(([k, v]) => v && !k.startsWith('_'))
            .map(([k, v]) => `${k}: ${v}`);
          const details = [...options, ...properties].join(', ');
          const url = location.origin + item.url.split('?')[0];
          return `• ${item.quantity} × ${item.product_title}${details ? ` (${details})` : ''} — ${money(item.final_line_price)}\n${url}`;
        });
        const message =
          `Hello SRX Diamonds! I'd like to place this order:\n\n${lines.join('\n\n')}` +
          `\n\nOrder total: ${money(cart.total_price)}` +
          (details ? `\n\nMy details:\n${details}` : '') +
          `\n\nPlease confirm availability and payment details.`;
        go('https://wa.me/' + btn.dataset.srxWaNumber + '?text=' + encodeURIComponent(message));
      } catch (e) {
        win?.close();
        console.warn('[srx-wa-order]', e);
      } finally {
        btn.disabled = false;
      }
    })();
  });
}
